import React from "react";

function TheDate() {
    return <div className="the-cartel fw6 mb4">Married the 6th of May 2023</div>;
}

export default TheDate